import { useEffect, useState } from "react";
import { Alert, Card, Table, Tag, message } from "antd";
import dayjs from "dayjs";
import { deadlineAPI } from "../services/api";

const DeadlinesPage: React.FC = () => {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void load();
  }, []);

  async function load() {
    setLoading(true);
    try {
      const data = await deadlineAPI.getUpcoming();
      setRows(Array.isArray(data) ? data : []);
    } catch (e: any) {
      message.error(e?.response?.data?.detail || "No se pudieron cargar plazos");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <Card title="Plazos próximos">
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
          message="Plazos con vencimiento próximo. Abra un caso para gestionar plazos específicos."
        />
        <Table
          rowKey={(r) => r.deadline_id || `${r.case_id}-${r.due_date}`}
          loading={loading}
          dataSource={rows}
          pagination={{ pageSize: 20 }}
          columns={[
            { title: "Caso", dataIndex: "case_number", key: "case_number" },
            { title: "Descripción", dataIndex: "description", key: "description" },
            {
              title: "Vence",
              dataIndex: "due_date",
              key: "due_date",
              render: (d: string) => (d ? dayjs(d).format("DD/MM/YYYY") : "—"),
            },
            {
              title: "Estado",
              dataIndex: "status",
              key: "status",
              render: (s: string) => <Tag color={s === "overdue" ? "red" : "blue"}>{s || "—"}</Tag>,
            },
          ]}
        />
      </Card>
    </div>
  );
};

export default DeadlinesPage;
